import { render, staticRenderFns } from "./UserProfileSaldo.vue?vue&type=template&id=d86c9d78&scoped=true&"
import script from "./UserProfileSaldo.vue?vue&type=script&lang=js&"
export * from "./UserProfileSaldo.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileSaldo.vue?vue&type=style&index=0&id=d86c9d78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86c9d78",
  null
  
)

export default component.exports